module.exports = __webpack_public_path__ + "static/media/IT26SBL.17d57014.png";